import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardHeader,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeliveryForm from "./components/DeliveryForm";
import InviteCustomerForm from "./components/InviteCustomerForm";
import MDBox from "components/MDBox";
import logo from "assets/images/icons/catering-icons/cr-logo-black.png";

const Incentive = () => {
  const [code, setCode] = useState(null);
  return (
    <>
      <MDBox component="img" src={logo} alt="Brand" width="100px" mx={2} mt={2} />
      <Container maxWidth="md">
        <Box my={2}>
          <Card>
            <CardHeader title="Incentive Program" titleTypographyProps={{ align: "center" }} />
            <CardContent
              sx={{
                padding: 2,
              }}
            >
              <Accordion defaultExpanded={!code}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Delivery Information</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <DeliveryForm setCode={setCode} code={code} />
                </AccordionDetails>
              </Accordion>
              {code && (
                <Box my={2}>
                  <Accordion defaultExpanded={!!code}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h6">Customer Invitation Options</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <InviteCustomerForm code={code} />
                    </AccordionDetails>
                  </Accordion>
                </Box>
              )}
            </CardContent>
          </Card>
        </Box>
      </Container>
    </>
  );
};

export default Incentive;
